var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 29.5,
    height: 29.5,
    rx: 14.75,
    fill: "#F2FCF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 29.5,
    height: 29.5,
    rx: 14.75,
    stroke: "#01C37D",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5072_107133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2375 10.9604C15.7658 10.4945 17.2533 11.5045 17.4992 12.9162C17.4992 13.6062 18.0592 14.1662 18.7492 14.1662C19.4392 14.1662 19.9992 13.6062 19.9992 12.9162C19.9992 12.7695 19.9692 12.6312 19.9233 12.5004C19.4158 9.5712 16.3617 7.49453 13.1283 8.68953C11.215 9.39703 10 11.2929 10 13.3329V13.3462C10.0008 13.737 10.0475 14.117 10.1342 14.482C10.3933 15.5737 11.8608 15.6995 12.3833 14.707C12.3883 14.697 12.3942 14.687 12.3992 14.677C12.5475 14.4037 12.6025 14.097 12.5442 13.792C12.4667 13.3887 12.4875 12.952 12.645 12.5004C12.8983 11.7737 13.5025 11.1862 14.2392 10.962L14.2375 10.9604Z",
    fill: "#01C37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84238 11.8374C9.07071 10.5099 9.71988 9.29992 10.7265 8.35576C12.0007 7.16159 13.669 6.57159 15.4182 6.67992C18.7124 6.89326 21.2882 9.77909 21.2499 13.2341C21.234 14.6808 20.0224 15.8324 18.5765 15.8324H16.4365C16.1482 15.3366 15.6165 14.9991 15.0007 14.9991C14.0799 14.9991 13.334 15.7449 13.334 16.6658C13.334 17.5866 14.0799 18.3324 15.0007 18.3324C15.6157 18.3324 16.1474 17.9949 16.4365 17.4991H18.5765C20.9257 17.4991 22.8832 15.6283 22.9165 13.2799C22.9782 8.92909 19.7099 5.28742 15.5257 5.01742C13.3057 4.87326 11.1999 5.62742 9.58738 7.14076C8.33821 8.31159 7.50738 9.86159 7.20821 11.5291C7.11738 12.0358 7.51821 12.5008 8.03238 12.5008C8.42571 12.5008 8.77655 12.2266 8.84238 11.8383V11.8374Z",
    fill: "#01C37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9666 19.167C12.1524 19.167 9.46489 20.8495 8.43323 23.2578C8.16156 23.8928 8.45573 24.6278 9.08989 24.8995C9.72573 25.1703 10.4599 24.8778 10.7316 24.2428C11.3707 22.7503 13.1524 21.667 14.9674 21.667C16.7824 21.667 18.6382 22.7745 19.2674 24.2428C19.4707 24.717 19.9324 25.0003 20.4174 25.0003C20.5816 25.0003 20.7482 24.9678 20.9091 24.8995C21.5441 24.6278 21.8374 23.892 21.5657 23.2578C20.5332 20.8487 17.8199 19.167 14.9682 19.167H14.9666Z",
    fill: "#01C37D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5072_107133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone2);
export default __webpack_public_path__ + "static/media/megaphone (2).575ab7d2d7739bc022f73820b8cded65.svg";
export { ForwardRef as ReactComponent };